"use strict";
/* globals module */
/**
 * @module filesStreamsClient
 * @description  Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var FilesStreamsClient = /** @class */ (function () {
    function FilesStreamsClient(filesStreamsRoute, apiClient) {
        this.filesStreamsRoute = filesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(FilesStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.filesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param id File id of the original file resource used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                        filesStreamsClient.get({id: '<path>'})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
                // Request derived file stream
                    filesStreamsClient.get({id: '<path>', width: <width>, height: <height>, t: <timestamp>})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    FilesStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example // Request the original blob
                    filesStreamsClient.getBlob('<path>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Request derived blob
                    filesStreamsClient.getBlob({id: '<path>', width: <width>, height: <height>, t: <timestamp>})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    FilesStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.filesStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @example // Update original file stream
                    filesStreamsClient.update('<path>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                // Update derived file stream
                    filesStreamsClient.update({id: '<path>', width: <width>, height: <height>}, <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    FilesStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.filesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example filesStreamsClient.create('<path>', <blob>)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    FilesStreamsClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.filesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    FilesStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.FilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.FilesStreamsRoute !== "undefined" && _1.FilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], FilesStreamsClient);
    return FilesStreamsClient;
}());
exports.FilesStreamsClient = FilesStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */
